<template>
<div>
	<div class="title">{{title||'申请人信息'}}</div>
	<Form :model="form" :label-width="150" class="mt15" :rules="formRules" ref="form">
	    <FormItem label="公司名称" class="w600" prop="companyName">
	        <Input 
	        	v-model="form.companyName" 
	        	placeholder="请输入营业执照上的公司名称"
				@on-blur="change"
	        	:maxlength="50">
	        </Input>
	    </FormItem>
	    <FormItem label="统一社会信用代码" class="w600" prop="organizationCode">
	        <Input 
	        	v-model="form.organizationCode" 
	        	placeholder="请输入营业执照上的统一社会信用代码"
				@on-change="resetUpperCaseValue"
				@on-blur="change"
	        	:maxlength="18"></Input>
	    </FormItem>
		<FormItem label="地区" prop="areaCode" class="w600">
			<Area v-model="form.areaCode" placeholder="请选择省市区" @get-city-str="areaChange"/>
		</FormItem>
	    <FormItem label="实际经营地址" class="w600" prop="address">
	        <Input v-model="form.address" placeholder="请输入实际经营地址" @on-blur="change" :maxlength="150"></Input>
	    </FormItem>
	    <FormItem label="联系人" class="w600" prop="contactsName">
	        <Input v-model="form.contactsName" placeholder="请输入联系人" :maxlength="20"></Input>
	    </FormItem>
	    <FormItem label="联系电话" class="w600" prop="contactsPhone">
	        <Input v-model="form.contactsPhone" placeholder="请输入手机号" @on-blur="change" :maxlength="20"></Input>
	    </FormItem>
	    <FormItem label="联系人邮箱" class="w600" prop="contactsEmail">
	        <Input v-model="form.contactsEmail" placeholder="请输入联系人邮箱" :maxlength="120"></Input>
	    </FormItem>
	    <FormItem label="联系人证件号" class="w600" prop="contactsCertificateNumber">
	        <Input v-model="form.contactsCertificateNumber" placeholder="请输入联系人证件号" :maxlength="40"></Input>
	    </FormItem>
		<FormItem label="营业执照" class="w600" prop="businessLicenseUrl">
	        <UploadFileImg 
				@on-success="val=>uploadSuccess(val,'businessLicenseUrl')" 
				:accept="['image']"
				style="width:100px">
				<div class="upload-img-main" v-if="!form.businessLicenseUrl">
					<Icon type="ios-camera" size="20"></Icon>
					<p>点击上传</p>
				</div>
				<img 
					:src="ossImg(form.businessLicenseUrl,'s')" 
					v-show="form.businessLicenseUrl" 
					width="100%" 
					style="display:block" />
			</UploadFileImg>
	    </FormItem>
	</Form>
</div>
</template>
<script>
import Area from '@/pages/haierProduct/components/common/Area'
import UploadFileImg from '@/components/common/UploadFileImg'
export default {
	components:{ Area,UploadFileImg },
	props:{
		info:Object,
		title:String
	},
	data () {
		return {
			form:this.info||{},
			formRules:{
				companyName:[{required:true,message:'公司名称必填',trigger:'blur'}],
				organizationCode:[{required:true,message:'统一社会信用代码必填',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.organizationCode}],
                address:[{required:true,message:'实际经营地址必填（最少6位）',min:6,trigger:'blur'}],
				contactsName:[{required:true,message:'联系人姓名必填',trigger:'blur'},{message:'请输入至少2个字',trigger:'blur',pattern:this.rules.chinaName}],
				contactsPhone:[{required:true,message:'请填写正确的手机号',trigger:'blur',pattern:this.rules.tel}],
				businessLicenseUrl:[{required:true,message:'营业执照必填',trigger:'change'}],
				contactsEmail:[{required:true,message:'邮箱格式不正确',trigger:'blur',type:'email'}],
				contactsCertificateNumber:[{required:true,message:'联系人证件号必填',trigger:'change'}],
				areaCode:[{required:true,message:'请选择地区',trigger:'change'}],
			}
		}
	},
	methods:{
		// 上传回调方法
		uploadSuccess(val,key){
			this.$set(this.form,key,val.url)
			this.$refs.form.validateField(key);
		},
		// 校验
		val () {
			return new Promise ((resolve,rejct)=>{
				this.$refs.form.validate(valid=>{
					resolve(valid?this.form:false)
				})
			})
		},
		// 回传给父组件，父组件传入开票组件，开票组件的公司名称和社会代码用此组件的值
		change() {
			this.$emit('on-change',this.form)
		},
		getInfo (companyName) {
			this.$post('/insurance2b/insurance/queryUserInfo',res=>{
				if(!res.data)return;
				this.$emit('on-data',res.data);
				this.$set(this.form,'organizationCode',res.data.organizationCode)
				this.$set(this.form,'areaCode',res.data.areaCode)
				this.$set(this.form,'address',res.data.address)
				this.$set(this.form,'zipCode',res.data.zipCode)
				this.$set(this.form,'contactsName',res.data.contactsName)
				this.$set(this.form,'contactsPhone',res.data.contactsPhone)
				this.$set(this.form,'businessLicenseUrl',res.data.businessLicenseUrl||"")
				if(res.data.invoiceType){
				    res.data.invoiceType += '';
				    this.$set(this.form,'invoiceType',res.data.invoiceType)
				    this.$set(this.form,'invoiceName',res.data.invoiceName)
				    this.$set(this.form,'taxpayerCode',res.data.taxpayerCode)
				    this.$set(this.form,'invoiceAddress',res.data.invoiceAddress)
				    this.$set(this.form,'invoicePhone',res.data.invoicePhone)
				    this.$set(this.form,'invoiceBank',res.data.invoiceBank)
				    this.$set(this.form,'publicAccount',res.data.publicAccount)
				}
			},{
				companyName:this.form.companyName
			})
		},
		areaChange(val){
			this.form.provinceCode=val[0].value
			this.form.provinceName=val[0].label
			this.form.cityCode=val[1].value
			this.form.cityName=val[1].label
			this.form.areaName=val[2].label
		},
		// 小写转大写
		resetUpperCaseValue(event){
			if(event.target.value){
				this.form.organizationCode=event.target.value.toUpperCase();
			}
		}
	},
	watch:{
		info (v) {
			this.form = v;
		},
	}
}
</script>
<style scoped lang="less">
	.upload-img-main{
		padding:10px 0;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/common/Applicant.vue